

<div class="card bg-warning">
  <div class="card-body ">
    <h3 class="card-title">A compter du 1er janvier 2025, la société PROVALT réalise les collectes d’équarrissage dans les départements suivant:</h3>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-4 px-4">
      <div class="col" *ngFor="let department of departments">
        <div class="row font-16 card-text pr-1">
          <div class="mr-1">{{department.name}}</div>
          <div class="">({{department.code}})</div>
        </div>
      </div>
    </div>
    <div class="card-footer font-16 mt-4">
      <span>Pour le départment du Doubs (25), certaines communes sont collectées par </span>
      <a class="font-italic" routerLink="/atemax" target="_blank">
        <span class="font-bold" >Atemax.</span>
        <span class=""> Consuler la liste des communes concernées (ici)</span>
      </a>
    </div>
  </div>
</div>
